import React, {Component} from 'react';
import {connect} from 'react-redux';
import {Loader, Popup, List} from 'semantic-ui-react';
import {Actions} from '../../../../../common/actions';

class User extends Component {
  fetchUserData(username) {
    this.props.fetchUser(username);
  }

  renderUserData() {
    const {loading, userData} = this.props;

    if (loading) {
      return <Loader active inline='centered' />;
    }
    if (!Object.keys(userData).length) {
      return <div className='user-container'>No hay datos disponibles</div>;
    }
    return (
      <List className='user-container'>
        <List.Item>
          <List.Icon size='large' name='user circle' />
          <List.Content>{userData.name}</List.Content>
        </List.Item>
        <List.Item>
          <List.Icon size='large' name='mail outline' />
          <List.Content>
            <a href={`mailto:${userData.email}`}>{userData.email}</a>
          </List.Content>
        </List.Item>
        <List.Item>
          <List.Icon size='large' name='call' />
          <List.Content>{userData.phone}</List.Content>
        </List.Item>
        <List.Item>
          <List.Icon size='large' name='industry' />
          <List.Content>{userData.province}</List.Content>
        </List.Item>
      </List>
    );
  }

  render() {
    const {username} = this.props;

    return (
      <Popup
        trigger={<span className='link'>{username}</span>}
        onOpen={() => this.fetchUserData(username)}
        content={this.renderUserData()}
        position='bottom right'
        on='click'
        hideOnScroll
      />
    );
  }
}

const mapStateToProps = (state, ownProps) => {
  const users = state.users.list;
  const username = ownProps.username;
  const position = users.findIndex((element) => element.username === username);
  const userData = position === -1 ? {} : users[position];

  return {
    'loading': state.users.loading,
    userData,
  };
};

const {
  fetchUser,
} = Actions;

export default connect(mapStateToProps, {
  fetchUser,
})(User);
